if (!customElements.get('pulse-product-tabs')) {
  class PulseProductTabs extends HTMLElement {
    connectedCallback() {
      this._initAccordion();
    }

    _initAccordion() {
      const headers = this.querySelectorAll('.ppt__accordion-header');
      headers.forEach((header) => {
        header.addEventListener('click', () => this._toggleItem(header));
      });
    }

    _toggleItem(header) {
      const item = header.closest('.ppt__item');
      if (!item) return;

      const isOpen = item.classList.toggle('is-active');
      header.setAttribute('aria-expanded', isOpen);
    }
  }

  customElements.define('pulse-product-tabs', PulseProductTabs);
}
